import React, { useState, useEffect } from "react";
import DisplayLongDescriptionAndVariantMFRName from "./DisplayLongDescriptionAndVariantMFRName";
import Cart from "@system/config/cart";
import noImage from 'src/assets/images/noimage.png'
import NavigateToProductDetail from "./NavigateToProductDetail";
import System from 'src/helper/system';
import { useProductStore } from 'src/hooks/product';
import Constants from 'src/helper/Constants';
import { useBOMStore } from "src/hooks/bom";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useCartStore } from "src/hooks/cart";
import { useSystem } from "src/hooks/system";

const AddedToCartNotification = (props) => {
    const { data, SetStatus } = props;
    const currentProductData = data?.data?.server_response?.data || {}
    const [{ bom_detail_by_bom_id,bom_detail_by_bom_id_type,bom_project_list}] = useBOMStore();
    const [loader, setLoader] = useState(false);
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [{ productList, model_ProductCompare_data }] = useProductStore();
    const [{ }, { fetch_cart_data }, { }] = useCartStore()
    const { currencyType: { USD } } = Constants
    const shortDes = productList[currentProductData?.itemNumber]?.ShortDescription || model_ProductCompare_data[currentProductData?.itemNumber]?.ShortDescription
    const [,{ get_quantity_format }] = useSystem();

    const onHide = () => {
        SetStatus(false)
    };

    useEffect(() => {
        async function fetchData() {
            addtoCartEvent();
            fetch_cart_data({ minicart: true })
        }
        fetchData()
    }, []);

    //By Ramya Kannan [Add to cart/BOM - Adobe script ]
    function addtoCartEvent() {
        let prodDetails = [currentProductData];
        let bomDetails = { ...bom_detail_by_bom_id };
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
        if (bom_project_list) {
            bomDetails.projectName =
                bom_project_list[bomDetails?.projectId]?.projectName;
        }
        prodDetails.forEach((data, key) => {
            let copyObj = { ...data };
            copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || 0;
            prodDetails[key] = copyObj;
        })
        let cartDetails = {
            additionSource: localStorage.getItem("additionSrcKey") || "BOM",
            cartType: "checkout",
            cartId: prodDetails[0]?.cartId
        };
        localStorage.setItem("adobeEventType", "addToCartEvent");
        if (Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({
                prodDetails,
                cartDetails,
                bomDetails,
            });
        }
    }
    return (
        <>
            <div>
                {currentProductData &&
                    <div className="avnet-modal modal-680">
                        <div className="avnet-modal-inner">
                            {/* Modal Header */}
                            <button type="button"
                                onClick={() => {
                                    onHide()
                                }}
                                className="close py-3" data-dismiss="modal">×
                            </button>
                            <div className="modal-header justify-content-center mt-0">
                                <h3 className="pcn-modal-heading pl-5">(1) Item(s) Added to Your Cart</h3>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body mb-4">
                                <div className="clearfix" />
                                <div className="add-to-cart-list">
                                    <div className="add-to-cart-item">
                                        <div className="bs5 row m-0">
                                            <div className="col-auto p-0">
                                                <div className="add-to-cart-item-img">
                                                    <img className="img-fluid"
                                                        src={currentProductData.assetURL ? currentProductData.assetURL : noImage} />
                                                </div>
                                            </div>
                                            <div className="col-auto p-0">
                                                <div className="add-to-cart-item-info">
                                                    <NavigateToProductDetail
                                                        data={{ SEOManufacturerName: currentProductData?.seoManufacturerName, SEOERPMFRPartNumber: currentProductData?.seoerpmfrPartNumber, ItemNumber: currentProductData?.itemNumber, ERPPartNumber: currentProductData?.erpMfrPartNumber }}>
                                                        <div className="text-blue">
                                                            <b>{currentProductData.erpMfrPartNumber}</b>
                                                        </div>
                                                    </NavigateToProductDetail>
                                                    <DisplayLongDescriptionAndVariantMFRName
                                                        currentProduct={{ ManufacturerName: currentProductData?.manufacturerName, ShortDescription: shortDes }} />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-auto mt-3 mt-sm-0 ms-auto p-0">
                                                <div className="add-to-cart-price">
                                                    <div className="add-to-cart-price-item">
                                                        <span>Unit Price:</span>
                                                        <b>{System.getFormatNumber({ amount: Number(currentProductData.unitPrice), currency: USD })}</b>
                                                    </div>
                                                    <div className="add-to-cart-price-item">
                                                        <span>Quantity:</span>
                                                        <b>{get_quantity_format(currentProductData.quantity)}</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-end mt-2 font-12 cart-subtotal">
                                    <span> Item Subtotal ({USD}): &nbsp;
                                        <b>
                                            {System.getFormatNumber({ amount: Number(currentProductData.subtotal), maximumFractionDigits: 2, isDisplaySymbol: false, currency: USD })}
                                        </b>
                                    </span>
                                </div>
                            </div>
                            {/* Modal footer */}
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">
                                    <button
                                    disabled={loader}
                                        onClick={() => {
                                            onHide()
                                        }}
                                        type="button" className="bs5 btn btn-secondary btn-sm w145 px-0"
                                        data-dismiss="modal">
                                        CONTINUE SHOPPING
                                    </button>
                                    <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                            disabled={loader}
                                        onClick={() => {
                                            setLoader(true);
                                            window.location.href = Cart.getCartPageRouteURL()
                                        }}
                                        data-dismiss="modal">
                                        {loader ? <i className="fa fa-spinner fa-spin" /> : "VIEW CART"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default AddedToCartNotification;